"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Id = exports.Timestamp = undefined;

var _flowClassyTypeWrapper = require("flow-classy-type-wrapper");

var _util = require("../../util");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.Timestamp = _util.Timestamp;

var Id = exports.Id = function (_TypeWrapper) {
  _inherits(Id, _TypeWrapper);

  function Id() {
    _classCallCheck(this, Id);

    return _possibleConstructorReturn(this, (Id.__proto__ || Object.getPrototypeOf(Id)).apply(this, arguments));
  }

  return Id;
}(_flowClassyTypeWrapper.TypeWrapper);
// State is a single user, the result of one query. Most redux examples operate
// on a list as state, which is great when you have everything in memory - it's
// what we do for unittypes. For the result of a query where we won't ever
// have all users in memory, it makes less sense
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvdXNlcnMvdHlwZXMuanMiXSwibmFtZXMiOlsiVGltZXN0YW1wIiwiSWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7QUFDQTs7Ozs7Ozs7UUFDUUEsUzs7SUFFS0MsRSxXQUFBQSxFOzs7Ozs7Ozs7OztBQUNiO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6InR5cGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7VHlwZVdyYXBwZXJ9IGZyb20gXCJmbG93LWNsYXNzeS10eXBlLXdyYXBwZXJcIlxuaW1wb3J0IHtUaW1lc3RhbXB9IGZyb20gXCIuLi8uLi91dGlsXCJcbmV4cG9ydCB7VGltZXN0YW1wfVxuXG5leHBvcnQgY2xhc3MgSWQgZXh0ZW5kcyBUeXBlV3JhcHBlcjxzdHJpbmc+IHt9XG4vLyBTdGF0ZSBpcyBhIHNpbmdsZSB1c2VyLCB0aGUgcmVzdWx0IG9mIG9uZSBxdWVyeS4gTW9zdCByZWR1eCBleGFtcGxlcyBvcGVyYXRlXG4vLyBvbiBhIGxpc3QgYXMgc3RhdGUsIHdoaWNoIGlzIGdyZWF0IHdoZW4geW91IGhhdmUgZXZlcnl0aGluZyBpbiBtZW1vcnkgLSBpdCdzXG4vLyB3aGF0IHdlIGRvIGZvciB1bml0dHlwZXMuIEZvciB0aGUgcmVzdWx0IG9mIGEgcXVlcnkgd2hlcmUgd2Ugd29uJ3QgZXZlclxuLy8gaGF2ZSBhbGwgdXNlcnMgaW4gbWVtb3J5LCBpdCBtYWtlcyBsZXNzIHNlbnNlXG5leHBvcnQgdHlwZSBTdGF0ZSA9IHtcbiAgK3VzZXJuYW1lOiA/c3RyaW5nLCAvLyBUT0RPIHJlbmFtZVxuICArY3JlYXRlZEF0OiBudW1iZXIsXG59XG5cbmV4cG9ydCB0eXBlIFByb3BzID0ge3VzZXJJZDogSWR9XG5leHBvcnQgdHlwZSBTZWxlY3Q8VD4gPSAoU3RhdGUsIGFueSkgPT4gVFxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/users/types.js
// module id = 91
// module chunks = 0